import { Box, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Icons } from '../../utils/icons.jsx'

const MarkdownCustomPreElement = ( { content, language } ) => {
    const [justCopied, setJustCopied] = useState( false )

    const { border, palette } = useTheme()

    const preContainerRef = useRef()

    const copyCode = async () => {
        try {
            await navigator.clipboard.writeText( content )
            setJustCopied( true )
            setTimeout( () => {
                setJustCopied( false )
            }, 3000 )
        } catch ( err ) {

        }
    }

    useEffect( () => {
        const container = preContainerRef.current
        if ( container && container.scrollTop + container.clientHeight < container.scrollHeight ) {
            container.scrollTop = container.scrollHeight
        }
    }, [content] )

    return (
        <Box
            sx={{
                overflow: "clip",
                borderRadius: "5px",
                border: `1px solid ${palette.common.font}`,
                marginY: "20px"
            }}>
            <Box
                sx={{
                    bgcolor: palette.background.paper,
                    borderBottom: `1px solid ${palette.common.font}`,
                    padding: "2px 10px",
                    display: "flex",
                    gap: "20px",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                <Typography variant='subtitle2'>{language}</Typography>
                <Tooltip placement='top' title={justCopied ? `Copied` : `Copy`}>
                    <IconButton onClick={copyCode} color={justCopied ? 'secondary' : "greyed"} size='small'>{Icons.default.Copy}</IconButton>
                </Tooltip>
            </Box>
            <Box
                ref={preContainerRef}
                className='slim-custom-scrollbar'
                component="pre"
                sx={{
                    overflow: "auto",
                    fontSize: "12px",
                    maxHeight: "500px",
                    bgcolor: palette.contentBg,
                    padding: "10px"
                }}>{content}</Box>
        </Box>
    );
}

export default MarkdownCustomPreElement